import React from 'react';

import Icon, { CircleIcon } from '../icon/icon';

import { formatFriendlyUrl } from '../../utilities/formatters.js';

import './styles.scss';

export default function SourceLink({ href }) {
  return (
    <a className="source-link" href={href} target="_blank">
      <Icon id="external-link" />
      <span>{formatFriendlyUrl(href)}</span>
    </a>
  );
}
